<section class="bg-blue-700 px-4 py-20 text-center sm:px-5 md:py-24">
  <div class="mx-auto max-w-5xl">
    <h2 class="text-4xl font-extrabold leading-tight text-white font-['Inter']">
      Comece a garimpar com clareza hoje
    </h2>
    <p class="mx-auto mt-5 max-w-3xl text-lg font-normal leading-relaxed text-blue-100 sm:text-xl font-['Inter']">
      Teste a Casato Brasil por 7 dias e veja a análise completa dos imóveis que importam pra você.
    </p>
    <a
      routerLink="/planos"
      class="mt-8 inline-flex items-center justify-center rounded-md bg-white px-5 py-2.5 text-sm font-medium text-blue-700 hover:bg-blue-50 focus:outline-none focus:ring-4 focus:ring-blue-300">
      Criar minha conta grátis
    </a>
    <p class="mt-4 text-sm font-medium text-blue-100 font-['Inter']">
      7 dias grátis · cancele quando quiser
    </p>
  </div>
</section>
